import styled, { css } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Button from 'builder/components/Button'
import Media from 'builder/styles/media'
import { PhrasesSuggestionContainer } from 'builder/components/PhrasesSuggestion'
import { ScrollContainer } from 'builder/components/ScrollContainer'
import Typography, { FontWeights } from 'builder/styles/typography'

interface SuggestionProps {
  isAnimationActive: boolean
}

export const Container = styled(PhrasesSuggestionContainer)`
  overflow: visible;
  width: 480px;
  border-radius: 8px;

  ${Media.Phone`
    border-radius: 0;
  `}

  ${props => Media.Desktop`
    margin-left: 16px;
    left: 100%;
    top: 21%;
    transform: translate(-8px, -50%);

    ${
      props.isVisible &&
      css`
        transform: translate(0, -50%);
        opacity: 1;
      `
    }
  `}
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  margin: 12px 16px 16px;
`

export const Title = styled.p`
  color: ${Colors.Indigo70};
  ${Typography.Caps};
`

export const Description = styled.p`
  color: ${Colors.Neutral50};
  ${Typography.Tiny};
`

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${Colors.Neutral15};
`

export const Suggestion = styled.div<SuggestionProps>(({ isAnimationActive }) => {
  return css`
    color: ${Colors.Neutral90};
    ${Typography.Body};
    margin: 8px 16px 16px;
    min-height: 216px;

    ${isAnimationActive &&
    css`
      color: ${Colors.Indigo50};
    `}

    ul {
      padding-inline-start: 20px;
    }
  `
})

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  width: 100%;
  padding: 16px;
`

export const AttemptsLeft = styled.div`
  color: ${Colors.Indigo60};
  ${Typography.Tiny};
`

export const RetryButton = styled(Button)`
  padding: 8px 12px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  border: 1px solid ${Colors.Neutral20};
  color: ${Colors.Neutral70};
  ${Typography.Caption};
  ${FontWeights.Medium};
  background-color: ${Colors.White};

  &:hover {
    background-color: ${Colors.White};
    border: 1px solid ${Colors.Indigo30};
    color: ${Colors.Indigo60};
  }
`

export const Icon = styled.div`
  path:first-child {
    fill: inherit;
  }
  path:not(:first-child) {
    fill: inherit;
  }
`

export const UseButton = styled(Button)`
  color: ${Colors.White};
  background-color: ${Colors.Indigo50};
  padding: 8px 24px;
  ${Typography.Caption};
  ${FontWeights.Medium};

  &:hover {
    background-color: ${Colors.Indigo60};
  }
`

export const CloseButton = styled(Button)`
  position: absolute;
  top: 12px;
  right: 12px;
  color: ${Colors.Neutral40};
  transition: color 0.1s;
  z-index: 999;
  background-color: ${Colors.White};
  padding: 0;

  &:hover {
    background-color: ${Colors.White};
  }
`

export const CloseButtonIconContainer = styled.div`
  pointer-events: none;
`

export const Scroll = styled(ScrollContainer)`
  overflow-y: scroll;
  max-height: 300px;

  ${Media.Phone`
    height: 250px;
    max-height: 250px;
  `}
`
